export default class Touchpoints {
  constructor(configuration) {
    this.container = configuration.container;
    this.randomizer = new TouchpointsRandomizer();

    this.currentIndex = -1;
    this.delay = 1000; // milliseconds
    this.screenType = ''; // sm, md or lg

    this.contactButton = this.container.querySelector('.touchpoints-button');
    this.backButton = this.container.querySelector('.touchpoints-back');
    this.backButton.onclick = () => {
      if (this.backButton.classList.contains('active')) {
        this.scrollToElement(this.container);
      }
    };

    this.items = Array.from(this.container.querySelectorAll('.touchpoints-item'));
    this.items.forEach((item) => {
      item.onmouseover = () => { item.classList.add('active'); };
      item.onmouseout = () => { item.classList.remove('active'); };
      item.onclick = (event) => {
        if (!item.hash) { return; }

        var element = document.querySelector(item.hash);
        if (!element) { return; }

        event.preventDefault();
        this.scrollToElement(element);
      };
    });

    this.update();
    window.addEventListener('load', this.update.bind(this));
    window.addEventListener('resize', this.update.bind(this));

    this.run();
  }

  // Run

  run() {
    if (this.isAboveViewport()) { this.currentIndex = -1; }
    if (this.isBelowViewport()) { this.currentIndex = this.displayedItems.length; }

    if (this.isInViewport() && !this.isHovered()) {
      if (!this.randomizer.isRunning) {
        this.randomizer.currentIndex = this.currentIndex;
        this.randomizer.start();
      }
    } else {
      if (this.randomizer.isRunning) {
        this.randomizer.stop();
      }
    }

    if (this.isInAndAboveViewport()) {
      if (!this.backButton.classList.contains('active')) {
        this.backButton.classList.add('active');
      }
    } else {
      this.backButton.classList.remove('active');
    }

    clearTimeout(this.timeout), this.timeout = 0;
    this.timeout = setTimeout(this.run.bind(this), this.delay);
  }

  isInAndAboveViewport() {
    return document.documentElement.scrollTop + window.innerHeight - 90 >=
      this.container.offsetTop + this.container.offsetHeight;
  }

  isAboveViewport() {
    return document.documentElement.scrollTop + window.innerHeight - 90 <= this.container.offsetTop;
  }

  isBelowViewport() {
    return document.documentElement.scrollTop >= this.container.offsetTop + this.container.offsetHeight;
  }

  isInViewport() {
    return !(
      (document.documentElement.scrollTop + window.innerHeight - 90 <= this.container.offsetTop) ||
      (document.documentElement.scrollTop >= this.container.offsetTop + this.container.offsetHeight)
    );
  }

  isHovered() {
    var result = false;

    this.displayedItems.forEach((item, index) => {
      if (item.classList.contains('active')) {
        this.currentIndex = index;
        result = true;
      }
    });

    return result;
  }

  // Scroll

  scrollToElement(element) {
    var isScrollBehaviorSupported = 'scrollBehavior' in document.documentElement.style;
    var options = {
      top: element.offsetTop,
      left: 0,
      behavior: 'smooth'
    };

    if (isScrollBehaviorSupported) {
      window.scroll(options);
    } else {
      window.scroll(options.left, options.top);
    }
  }

  // Update

  update() {
    if (window.innerWidth < 768) {
      if (this.screenType === 'sm') { return; }
      this.screenType = 'sm';

      this.updateDisplayedItems();
    } else if (768 <= window.innerWidth && window.innerWidth < 1024) {
      if (this.screenType === 'md') { return; }
      this.screenType = 'md';

      this.updateDisplayedItems();
      if (this.displayedItems.length > 2) {
        this.displayedItems[2].classList.add('clear');
      } else if (this.displayedItems.length === 2) {
        if (this.contactButton) {
          this.contactButton.classList.add('clear');
        }
      }
    } else if (1024 <= window.innerWidth) {
      if (this.screenType === 'lg') { return; }
      this.screenType = 'lg';

      this.updateDisplayedItems();
      if (this.displayedItems.length > 4) {
        this.displayedItems[4].classList.add('clear');
      } else if (this.displayedItems.length === 4) {
        if (this.contactButton) {
          this.contactButton.classList.add('clear');
        }
      }
    }
  }

  updateDisplayedItems() {
    this.displayedItems = [];

    this.items.forEach((item) => {
      item.classList.remove('clear');

      if (getComputedStyle(item).display !== 'none') {
        this.displayedItems.push(item);
      }
    });

    if (this.contactButton) {
      this.contactButton.classList.remove('clear');
    }

    this.randomizer.setItems(this.displayedItems);
  }
}

class TouchpointsRandomizer {
  constructor() {
    this.currentIndex = -1;
    this.delay = 2000; // milliseconds
    this.isRunning = false;
    this.items = [];
    this.flags = [];
  }

  start() {
    this.isRunning = true;

    if (!this.timeout) {
      this.timeout = setTimeout(this.run.bind(this), 0);
    }
  }

  resume() {
    if (!this.timeout) {
      this.timeout = setTimeout(this.run.bind(this), this.delay);
    }
  }

  pause() {
    if (this.timeout) {
      clearTimeout(this.timeout), this.timeout = 0;
      this.items.forEach((item) => { item.classList.remove('random'); });
    }
  }

  stop() {
    this.isRunning = false;
    this.clearFlags();

    if (this.timeout) {
      clearTimeout(this.timeout), this.timeout = 0;
      this.items.forEach((item) => { item.classList.remove('random'); });
    }
  }

  run() {
    this.pause();

    if (this.items.length > 1) {
      this.checkFlags();

      if (this.currentIndex < 0) {
        this.currentIndex = 0;
      } else if (this.currentIndex >= this.items.length) {
        this.currentIndex = this.items.length - 1;
      } else {
        this.currentIndex = this.getIndex();
      }

      this.items[this.currentIndex].classList.add('random');
      this.flags[this.currentIndex] = true;

      this.checkFlags();
    }

    this.resume();
  }

  setItems(items) {
    this.items = items;
    this.clearFlags();
  }

  checkFlags() {
    if (this.flags.every(flag => flag)) {
      this.clearFlags();
      this.flags[this.currentIndex] = true;
    } else if (this.flags.every(flag => !flag)) {
      this.flags[this.currentIndex] = true;
    }
  }

  clearFlags() {
    this.flags = new Array(this.items.length);
    this.flags.fill(false);
  }

  getIndex() {
    var available = [];
    for (var i = 0; i < this.items.length; i++) {
      if (!this.flags[i]) {
        available.push(i);
      }
    }

    if (available.length > 0) {
      var random = Math.floor(Math.random() * Math.floor(available.length));
      return available[random];
    } else {
      return this.currentIndex;
    }
  }
}
